import { Tooltip } from 'components/Tooltip/Tooltip'
import { FINANCIAL_STATUS_LABEL } from '../constants'
import { getRebatesStatusTooltip } from './RebatesTable/helpers'
import { FINANCIAL_STATUS_TYPES_TO_CLASSNAME, Status } from 'components/Status'
import { TRebatesTableType } from './RebatesTable/types'

export const RebatesStatusCell = ({ row }: { row: TRebatesTableType }) => {
  const { status } = row
  return (
    <Tooltip title={getRebatesStatusTooltip(row)}>
      <div>
        <Status.Default className={FINANCIAL_STATUS_TYPES_TO_CLASSNAME[status]}>
          {FINANCIAL_STATUS_LABEL[status]}
        </Status.Default>
      </div>
    </Tooltip>
  )
}
